<template>
  <div>
    <div class="form-row px-0 mx-0">
      <label class="label-style" for="validationCustom01">{{$t(selectLabel)}}</label>
      <b-form-select
        class="label-text"
        :id="selectId"
        :options="selectOption"
        :required="isRequired"
        v-validate="validation"
        :name="errorMessage"
        :value="selectedValue"
        @change="$emit('selectedOption', $event)"
        @click="$emit('selectedOption', $event)"
      />
    </div>
    <div
      class="helo-block alert alert-danger mt-1 w-100"
      v-show="errors.has(errorMessage)"
    >{{errors.first(errorMessage)}}</div>
  </div>
</template>

<script>
export default {
  props: [
    "selectLabel",
    "selectedValue",
    "selectOption",
    "selectId",
    "isRequired",
    "validation",
    "errorMessage"
  ]
};
</script>

